import { render, staticRenderFns } from "./MajorAssumption.vue?vue&type=template&id=4ead5998&scoped=true&"
import script from "./MajorAssumption.vue?vue&type=script&lang=js&"
export * from "./MajorAssumption.vue?vue&type=script&lang=js&"
import style0 from "./MajorAssumption.vue?vue&type=style&index=0&id=4ead5998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead5998",
  null
  
)

export default component.exports